import { DefaultApi } from './api'
import { VehicleBodiesData, VehicleData, VehicleLocatorData, VehiclePayload, VehicleTrackerData, VehicleTypesData } from './types'

const path = '/vehicle'

export const get = () =>
  DefaultApi.request<VehicleData>(`/vehicles`, { method: 'GET', withCredentials: true })

export const create = (data: VehiclePayload) =>
  DefaultApi.request(`/vehicles`, { method: 'POST', data, withCredentials: true })

export const update = (vehicleId: string, data: VehiclePayload) =>
  DefaultApi.request(`/vehicles/${vehicleId}`, { method: 'PATCH', data, withCredentials: true })

export const listBodies = () =>
  DefaultApi.request<VehicleBodiesData>(`${path}/bodies`, { method: 'GET', withCredentials: true })

export const listTypes = () =>
  DefaultApi.request<VehicleTypesData>(`${path}/types`, { method: 'GET', withCredentials: true })

export const listTrackers = () =>
  DefaultApi.request<VehicleTrackerData>(`${path}/trackers`, { method: 'GET', withCredentials: true })

export const listLocators = () =>
  DefaultApi.request<VehicleLocatorData>(`${path}/locators`, { method: 'GET', withCredentials: true })
